import { useEffect, useState } from 'react';

import { Header } from './components/Header';
import { ShowTask } from './components/ShowTask';
import { AddTask } from './components/AddTask';

import './App.css';


function App() {

  const [tasklist, setTasklist] = useState(JSON.parse(localStorage.getItem("tasklist")) || []);
  const [task, setTask] = useState([]);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("newest");

  useEffect(() => {
    localStorage.setItem("tasklist", JSON.stringify(tasklist))
  }, [tasklist])

  return (
    <div className="App">
      <Header />

      <AddTask 
        tasklist={tasklist} 
        setTasklist={setTasklist} 
        
        task={task} 
        setTask={setTask}
      />

      <ShowTask 
        tasklist={tasklist} 
        setTasklist={setTasklist} 
        
        task={task} 
        setTask={setTask}
        
        search={search}
        setSearch={setSearch}

        sortType={sortType}
        setSortType={setSortType}
      />

    </div>
  );
}

export default App;